import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../Firebase Functions/firebase";
import "../TruckServices/ChecklistForm.css";

const IncidentReportViewer = () => {
  const { id } = useParams();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const docRef = doc(db, "incidentReports", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setReport({ id: docSnap.id, ...docSnap.data() });
        } else {
          console.error("No such document!");
        }
      } catch (err) {
        console.error("Error fetching report:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [id]);

  if (loading) return <p>Loading report...</p>;
  if (!report) return <p>Report not found.</p>;

  return (
    <div className="checklist-form">
      <h1 className="form-title">Incident Report</h1>
      <p><strong>Employee:</strong> {report.employee?.name}</p>
      <p><strong>Status:</strong> {report.status}</p>
      <p><strong>Division:</strong> {report.employee?.division}</p>
      <p><strong>Occurrence Date:</strong> {report.occurrence?.injuryDate}</p>
      <p><strong>Location:</strong> {report.occurrence?.location}</p>

      {report.supervisor?.signature && (
        <div>
          <h3>Supervisor Signature</h3>
          <img
            src={report.supervisor.signature}
            alt="Supervisor Signature"
            style={{ width: "300px", border: "1px dashed #ccc" }}
          />
        </div>
      )}
      {report.driver?.signature && (
        <div>
          <h3>Driver Signature</h3>
          <img
            src={report.driver.signature}
            alt="Driver Signature"
            style={{ width: "300px", border: "1px dashed #ccc" }}
          />
        </div>
      )}
      {report.attachments?.imageURLs?.length > 0 && (
        <div>
          <h3>Attached Photos</h3>
          <div className="image-preview-grid">
            {report.attachments.imageURLs.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Attachment ${index + 1}`}
                style={{ width: "150px", margin: "5px" }}
              />
            ))}
          </div>
        </div>
      )}

      {/* Organized Request Actions (Only “Go to” Buttons) */}
      <div style={{ marginTop: "40px" }}>
        <h2 style={{ color: "#2c3e50", marginBottom: "20px" }}>Request Actions</h2>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {[
  {
    title: "Check Request",
    bg: "#2c3e50",
    route: "/check-request-form",
  },
  {
    title: "P.O. Request",
    bg: "#6d4c41",
    route: "/payout-request",
  },
  {
    title: "Credit Card Request",
    bg: "#007820",
    route: "/vendor-request",
  },
  {
    title: "Payroll Deduction",
    bg: "#8e44ad",
    route: "/payroll-deduction",
  },
].map((req, idx) => (

            <div
              key={idx}
              style={{
                flex: "1 1 300px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "20px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              }}
            >
              <h3 style={{ color: req.bg }}>{req.title}</h3>
              <p style={{ fontSize: "0.9rem", color: "#555" }}>
                Use this to complete the {req.title.toLowerCase()}.
              </p>
              <button
                onClick={() => navigate(req.route, { state: { incidentId: report.id } })}
                style={{
                  backgroundColor: req.bg,
                  color: "white",
                  padding: "10px 16px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                Go to {req.title}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IncidentReportViewer;
